module.exports = __webpack_public_path__ + "assets/img/init_pos_wallpaper3.7c0f40b8.png";